import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className="descriptionbox" > 
     <div className="descriptionbox-navigator">
        <div className="description-nav-box">Description</div>
        <div className="description-nav-box-1">Reviews(122)</div>

     </div>
        <div className="descriptionbox-description">
            <p>An e-commerce product that includes a list of products that you can purchase at any time and will receive a copy of the product on your website and will receive a copy of the product on your website and will receive a copy of the product on your website and will receive a copy of
            the product on your website and will receive a copy of the product on your website and will receive a copy of the product on your website and will receive a copy of the product on your website and will receive a copy of the product on your website and will receive a copy of the product on your website and will receive a copy of the product on your website and will 
            receive a copy of the product on your website and will receive a copy of the product on your website and will receive a copy
                 </p>

        </div>
    
    </div>
  )
}

export default DescriptionBox